export default __webpack_public_path__ + "static/media/ServiceNotice.c2e0482b.svg";